<template>
  <div
    ref="component"
    class="tva-line-chart-component"
    v-resize="onResize"
    :style="{
      width: config.globalFixedWidth ? config.globalFixedWidth + 'px' : '100%',
      height: config.globalFixedHeight
        ? config.globalFixedHeight + 'px'
        : '100%',
      fill: 'transparent',
    }"
  >
    <svg>
      <Grid :p="params" :c="config" :d="data" />
      <g class="bubbles" v-for="serie in config.series" :key="serie.key">
        <Bubbles
          :p="params"
          :c="config"
          :d="computedData"
          :serie="serie"
          :globalIndex="globalIndex"
        />
      </g>
      <XAxis :p="params" :c="config" :d="computedData" />
      <YAxis :p="params" :c="config" />
      <Legend :p="params" :c="config" />
      <g
        class="tooltips"
        v-for="serie in config.series"
        :key="'tooltip-' + serie.key"
      >
        <TooltipScatterPlot
          :p="params"
          :c="config"
          :d="computedData"
          :serie="serie"
        />
      </g>
      <g>
        <circle
          :cx="
            params.width -
            computedWidth(computedText) -
            params.scaleR(legendValue) / (legendValue < 100 ? 1 : 2)
          "
          :cy="62"
          :r="params.scaleR(legendValue)"
          class="legend-circle"
          fill="red"
        ></circle>
        <text :x="params.width - 180" :y="67" fill="#fff" class="legend-label">
          {{ computedText }}
        </text>
      </g>
    </svg>
  </div>
</template>

<script>
import global from "@/charts/mixins/global";
import grid from "@/charts/mixins/grid";

import Grid from "@/charts/components/Grid";
import Bubbles from "@/charts/components/Bubbles";
import XAxis from "@/charts/components/XAxis";
import YAxis from "@/charts/components/YAxis";
import Legend from "@/charts/components/Legend";
import TooltipScatterPlot from "./components/TooltipScatterPlot..vue";
import wrap from "@/charts/mixins/wrap.js";

export default {
  props: ["data", "config", "globalIndex", "legendValue"],
  mixins: [global, grid, wrap],
  computed: {
    params() {
      return {
        width: this.width,
        height: this.height,
        left: this.left,
        right: this.right,
        minX: this.maxMinX.min,
        maxX: this.maxMinX.max,
        minY: this.maxMinY[0].min,
        maxY: this.maxMinY[0].max,
        ticksX: this.ticksX,
        ticksY: this.ticksY,
        scaleX: this.scaleX,
        scaleY: this.scaleY,
        scaleR: this.scaleR,
        format: this.format,
        tooltipMove: this.tooltipMove,
      };
    },
    computedText() {
      return " = " + this.$n(this.legendValue) + " thousand barrels/day";
    },
  },
  methods: {
    computedWidth(text) {
      const textWidth = this.measureText(text.toString(), 16);
      return textWidth;
    },
  },
  components: {
    Grid,
    Bubbles,
    XAxis,
    YAxis,
    Legend,
    TooltipScatterPlot,
  },
};
</script>

<style lang="scss" scoped>
.tva-line-chart-component {
  width: 100%;
  height: 100%;

  svg {
    width: 100%;
    height: 100%;
  }
}

.legend-label {
  @include dida-S;
}

.legend-circle {
  stroke: var(--source-color-dark);
  stroke-width: toRem(1);
  fill: $white_02;
}
</style>
